import styled, { css } from 'styled-components';

export const CompactTabWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;

  :hover {
    background-color: ${({ theme }) => theme.neutralBackgroundHover};

    > svg {
      background-color: transparent;
    }
  }
`;

export const CompactTabContainer = styled.div<{ isActive?: boolean }>(
  ({ theme, isActive }) => css`
    background-color: ${isActive ? theme.neutralBackgroundBase : 'transparent'};
    /* A flex box centres the 16px icon. As an inline box it sat on the 24px line's baseline,
       15px from the top and 21px from the bottom; 18px padding keeps the 52px height. */
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 18px 16px;
    border-radius: 6px;

    > svg {
      color: ${isActive ? theme.primaryText : theme.neutralTextWeak};
    }
  `,
);
